import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
const useStyles = makeStyles((theme) => ({
  container: {
    // maxHeight: 250,
    // minHeight: 250,
    paddingTop: theme.spacing(1),
    alignContent: 'center',
    alignItems: 'center',
    verticalAlign: 'center'
  },
  paddingTop: {
    // paddingTop: theme.spacing(8),
    // paddingBottom: theme.spacing(1),
  },
  paddingBottom: {
    paddingBottom: theme.spacing(0),
  }
}));

function LeftPane(props) {
  const classes = useStyles();

  return (
    <Paper elevation={3} className={classes.container}>
      <Typography className={classes.paddingBottom}
        style={{ color: 'gray' }}
        variant="h6"
        align='center'>
        {props.title}
      </Typography>
      <Typography
        className={classes.paddingBottom}
        // style={{ fontSize: '60px' }}
        variant="h4"
        align='center'>
        {props.value}
      </Typography>
      <br />
    </Paper>
  );
}

export default LeftPane;
